import { Component, forwardRef, HostBinding, HostListener,  EventEmitter } from '@angular/core';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { noop } from 'rxjs';

const CHECKBOX_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => UICheckboxComponent),
  multi: true
};

const CHECKBOX_VALIDATORS = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => UICheckboxComponent),
  multi: true
};

@Component({
  selector: 'ui-checkbox',
  templateUrl: 'checkbox.component.html',
  styleUrls: ['checkbox.component.scss'],
  providers: [CHECKBOX_CONTROL_VALUE_ACCESSOR, CHECKBOX_VALIDATORS]
})
export class UICheckboxComponent implements ControlValueAccessor, Validator {
  private _onChange: Function = noop;

  private _onTouched: Function = noop;

  @HostBinding('attr.checked')
  @Input()
  checked: boolean;

  @HostBinding('attr.disabled')
  @Input()
  disabled: boolean;

  @Output()
  change = new EventEmitter();

  private _required: boolean;

  @HostBinding('attr.required')
  @Input()
  set required(value: boolean) {
    this._required = value !== false;
  }

  @Input()
  name: string;

  @HostListener('click', ['$event'])
  private _onClick(event: MouseEvent): void {
    this._toggle(event);
  }

  @HostListener('keydown.space', ['$event'])
  private _onSpaceDown(event: KeyboardEvent): void {
    this._toggle(event);
  }

  @HostListener('keydown.spacebar', ['$event'])
  private _onSpacebarDown(event: KeyboardEvent): void {
    this._toggle(event);
  }

  private _toggle(event: UIEvent): void {
    if (this.disabled === undefined) {
      this.checked = !this.checked;
      this._onChange(this.checked);
      this._onTouched();
      this.change.emit(event);
    }
  }

  writeValue(value: any): void {
    this.checked = value;
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): { [key: string]: any; } {
    if (!this._required || this.checked) {
      return null;
    }
    return { required: { valid: false } };
  }
}
